import cx from 'classnames'
import type React from 'react'

import { FormControl, FormHelperText, RecommendationSelect } from '@components/ui/FormElements'
import { Input, InputLabel } from '@components/ui/InputElements'

interface RenderRecommendationTextFieldProps {
  label: string
  labelClassName?: string
  meta: {
    touched: boolean
    error?: string
  }
  options?: string[]
  input: {
    name: string
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    value: string
  }
  disabled?: boolean
  positioner?: (event: React.ChangeEvent<HTMLInputElement>, value: string, previousValue: string) => void
}

export function RenderRecommendationTextField({
  label,
  labelClassName,
  meta: { touched, error },
  options = [],
  input,
  disabled,
  positioner,
}: RenderRecommendationTextFieldProps) {
  const hasError = touched && Boolean(error)
  const hasRecommendations = options.length > 0

  return (
    <FormControl error={hasError}>
      {label && (
        <InputLabel htmlFor={input.name} error={hasError} className={labelClassName}>
          {label}
        </InputLabel>
      )}
      {hasRecommendations ? (
        <RecommendationSelect
          id={input.name}
          recommendations={options}
          field={{
            value: input.value,
            onChange: input.onChange,
          }}
          className={cx({ error: hasError })}
          disabled={disabled}
        />
      ) : (
        <Input
          id={input.name}
          {...input}
          onChange={event => {
            input.onChange(event)
            if (typeof positioner === 'function') {
              positioner(event, event.target.value, input.value)
            }
          }}
          disabled={disabled}
        />
      )}
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}
